import { createSlice } from '@reduxjs/toolkit'

export const LoginReducer = createSlice({
    name: 'loginData',
    initialState: {
        loginData: null,
    },
    reducers: {
        LoginUser: (state, action) => {
            state.loginData = action.payload
        },
        UpdateTokenChr: (state, action) => {
            state.loginData.token_chr = action.payload.token_chr;
        },
    },
})

// Action creators are generated for each case reducer function
export const { LoginUser, UpdateTokenChr } = LoginReducer.actions

export default LoginReducer.reducer